import { IResponseModel } from "../../IResponseModel";

export class ChangePasswordResponse implements IResponseModel {
}